import { ProfileDetails } from './ProfileDetails';
import { ActionButtons } from './ActionButtons';
import type { ProfessionalMessageProps } from './types';
import { BASE_STYLE } from './style';

/**
 * Displays detailed information about a team member including summary and contact options
 */

interface ProfileDetailCardProps {
    name: string;
    summary?: string;
    nzrab?: string;
    id: number;
    professionalId: number;
    professionalProps: ProfessionalMessageProps;
    category: string;
}

export const ProfileDetailCard = ({
    name,
    summary,
    nzrab,
    professionalProps,
    category,
}: ProfileDetailCardProps) => {
    const isSummary = !!summary?.length;
    return (
        <div className={`${BASE_STYLE.GAP_LARGE} mt-5 flex flex-col`}>
            <ProfileDetails name={name} summary={summary} nzrab={nzrab} />

            <ActionButtons
                name={name}
                summary={isSummary}
                category={category}
                professionalProps={professionalProps}
            />
        </div>
    );
};
